import LiveStreamChat from "../../../components/LiveStreamChat";

const ViewFlatList = (props) => {
  const { videoId, categoryId, cardId } = props;
  return (
    <>
        <LiveStreamChat
          videoId={videoId}
          categoryId={categoryId}
          cardId={cardId}
        >
        </LiveStreamChat>
    </>
  );
};

export default ViewFlatList;
